import { useParams, Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'
import { ALL_ARTICLES, formatDate } from '../lib/articles.js'

/*
 * Admin-only preview of ANY article — including scheduled and draft ones that
 * aren't public yet — so the team can review before it goes live. Gated by
 * RequireAdmin and noindex'd; it renders the bundled Markdown just like the public
 * page. Live articles are also viewable here, but their public URL is canonical.
 */
const BADGE = {
  live: { label: 'Live', cls: 'green' },
  scheduled: { label: 'Scheduled', cls: 'blue' },
  draft: { label: 'Draft', cls: '' },
}

export default function AdminArticlePreview() {
  const { slug } = useParams()
  const a = ALL_ARTICLES.find((x) => x.slug === slug)

  if (!a) {
    return (
      <main className="page">
        <Seo title="Preview not found — Admin" noindex />
        <div className="container page-narrow" style={{ padding: '40px 0', textAlign: 'center' }}>
          <h1 className="section-title">Article not found</h1>
          <p className="section-sub">No article file matches “{slug}”.</p>
          <Link to="/admin/articles" className="btn btn-primary">← All articles</Link>
        </div>
      </main>
    )
  }

  const b = BADGE[a.status] || BADGE.draft

  return (
    <main className="page">
      <Seo title={`Preview: ${a.title} — Admin`} noindex />
      <div className="container page-narrow">
        <Link to="/admin/articles" className="pep-back">← All articles</Link>

        {/* preview banner so nobody mistakes this for the live page */}
        <div className="config-notice" style={{ margin: '10px 0 18px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
          <span className={`pill ${b.cls}`}>{b.label}</span>
          <strong>Team preview.</strong>
          <span className="muted small">
            {a.status === 'live'
              ? <>This is published — <Link to={`/articles/${a.slug}`}>view the public page</Link>.</>
              : a.status === 'scheduled'
                ? `Not public yet — auto-publishes ${formatDate(a.publishAt)}.`
                : 'Draft — will not publish until its draft flag is cleared and its date arrives.'}
          </span>
        </div>

        <article className="article">
          <header className="article-head">
            <h1 className="article-title">{a.title}</h1>
            <div className="article-meta">
              <span>{formatDate(a.date)}</span>
              <span aria-hidden>·</span>
              <span>{a.readingMins} min read</span>
              {a.tags.map((t) => <span key={t} className="pep-tag">{t}</span>)}
            </div>
          </header>

          <div className="prose" dangerouslySetInnerHTML={{ __html: a.html }} />

          <p className="article-disclaimer">
            Educational only — not medical advice. (This disclaimer + a calculator CTA also render on the public page.)
          </p>
        </article>
      </div>
    </main>
  )
}
